import React from 'react'
import type { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import providerAndMemberScene from '../../assets/providerAndMemberScene.png'
import { useGetResponsiveAssets } from '../../hooks/useGetResponsiveAssets'
import { tID } from '../../utils'
import { Image } from '../image/Image'

type ForkedTriageMainCareOptionIllustrationProps = {
  width?: number
  height?: number
}

const ImageContainer = styled(Image)<{ height: number; width: number }>(({ height, width }) => ({
  height: `${height}px`,
  width: `${width}px`,
}))

export const ForkedTriageMainCareOptionIllustration: FunctionComponent<ForkedTriageMainCareOptionIllustrationProps> = ({
  width,
  height,
}) => {
  const {
    assets: { forkedTriageMainCareOptionIllustration },
  } = useTheme()

  const imageUrl = useGetResponsiveAssets(forkedTriageMainCareOptionIllustration?.assetNames ?? { defaultAsset: '' })
  const imageDimensions = { width: 241, height: 170 }
  if (imageUrl) {
    imageDimensions.width = 205
    imageDimensions.height = 129
  }
  if (width && height) {
    imageDimensions.width = width
    imageDimensions.height = height
  }

  return (
    <ImageContainer
      height={imageDimensions.height}
      width={imageDimensions.width}
      testID={`${tID('ForkedTriageMainCareOptionIllustration')}`}
      source={imageUrl ? { uri: imageUrl } : (providerAndMemberScene as ImageSourcePropType)}
    />
  )
}
